
// src/helpers/run-after-interactions.js

function runAfterInteractions(func) {
  return func()
}

export default runAfterInteractions



// WEBPACK FOOTER //
// ./src/helpers/run-after-interactions.js